module.exports = __webpack_public_path__ + "static/calendar_data_sources_color-ac3fb14dbd823f9123784e955a55315a.png";